import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Select,
  FormControl,
  MenuItem,
  Typography,
  TextField,
  Paper,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import React from "react";
import { formatCurrency, formatDate } from "../../../utils/utils";

const headerStyles = {
  fontSize: "0.55rem",
  fontWeight: 600,
};

const DeletedPayments = ({ deletedPayments }: { deletedPayments: any }) => {
  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ p: 1 }}>
            <TableCell sx={headerStyles}>Type</TableCell>
            <TableCell sx={headerStyles}>Amount</TableCell>
            <TableCell sx={headerStyles}>Mode</TableCell>
            <TableCell sx={headerStyles}>Received From</TableCell>
            <TableCell sx={headerStyles}>Location</TableCell>
            <TableCell sx={headerStyles}>Date</TableCell>
            <TableCell sx={headerStyles}>Updated On</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deletedPayments && deletedPayments?.length > 0 ? (
            deletedPayments?.map((payment: any, idx: number) => {
              return (
                <TableRow key={idx}>
                  <TableCell>
                    <Typography sx={{ fontSize: "0.55rem" }}>
                      {payment?.type || "N/A"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "0.55rem" }}>{`${formatCurrency(
                      payment?.paymentAmount || payment?.amount
                    )}`}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "0.55rem" }}>
                      {payment?.paymentMode || payment?.mode}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "0.55rem" }}>
                      {payment?.paymentReceivedFrom || payment?.receivedFrom}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "0.55rem" }}>
                      {payment?.paymentLocation || payment?.location}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "0.55rem" }}>
                      {formatDate(payment?.paymentDate || payment?.date)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{ fontStyle: "italic", fontSize: "0.55rem" }}
                    >
                      {formatDate(payment?.updatedAt || payment?.createdOn)}
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={7} align="center">
                No payment details available.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DeletedPayments;
